// Analytics – GA4 + Meta Pixel with graceful fallback.
// Set REACT_APP_GA4_ID and/or REACT_APP_META_PIXEL_ID in /app/frontend/.env
// If empty, the tracker scripts are NOT loaded and track() becomes a no-op.

const GA4_ID = process.env.REACT_APP_GA4_ID || "";
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

let initialised = false;

function loadScript(src, attrs = {}) {
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.async = true;
    s.src = src;
    Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
}

export function initAnalytics() {
  if (initialised || typeof window === "undefined") return;
  initialised = true;

  // ————— Google Analytics 4 —————
  if (GA4_ID) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { send_page_view: true });
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`).catch(
      () => {}
    );
  }

  // ————— Meta (Facebook) Pixel —————
  if (META_PIXEL_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
    /* eslint-enable */
    window.fbq("init", META_PIXEL_ID);
    window.fbq("track", "PageView");
  }
}

/**
 * Track a custom event to GA4 and Meta Pixel (if configured).
 * eventName: standard/custom name (ex: "whatsapp_click", "catalog_download")
 * params: object with metadata (ex: { source: "hero", product: "Amazonas Cap CB" })
 */
export function track(eventName, params = {}) {
  try {
    if (typeof window === "undefined") return;
    // GA4
    if (window.gtag && GA4_ID) {
      window.gtag("event", eventName, params);
    }
    // Meta Pixel – uses trackCustom for arbitrary names
    if (window.fbq && META_PIXEL_ID) {
      window.fbq("trackCustom", eventName, params);
    }
    // Console for local debug
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.debug("[analytics]", eventName, params);
    }
  } catch (_e) {
    /* swallow */
  }
}
